<template>
  <SysDialogFullscreen v-model="DIALOG_ATIVO_COMPUTED">
    <template #titulo.text>
      <div>
        <p class="ma-0 font-20 font-weight-medium">Exportação para o ERP</p>
        <p class="ma-0 mt-n3 font-13 font-weight-regular ">
          Exportação do pedido #{{ pedido.idpedido }} com {{ produtos_pedido.length }} produto{{ produtos_pedido.length > 1 ? 's' : ''}}
        </p>
      </div>
    </template>

    <template #titulo-parte-direita>
      <v-btn
        v-if="exportacao_valida_computed"
        color="primary"
        @click="exportar"
      >
        ok, exportar
      </v-btn>

      <ErrosDialog v-else />
    </template>

    <div
      v-if="DIALOG_ATIVO_COMPUTED"
      class="pt-5 px-4 bg-gray-200"
      style="height: calc(100vh - 65px)"
    >
      <v-card class="pa-5">
        <div class="d-flex align-center justify-space-between">
          <div class="w-25-porcento pr-2">
            <SysFilialGrupoAutocomplete
              v-model="exportacao.codigo_filial"
              label="Filial*"
              outlined
              hide-details
            />
          </div>

          <div class="w-25-porcento px-2">
            <SysCompradorAutocomplete
              v-model="exportacao.codigo_comprador"
              label="Comprador*"
              outlined
              hide-details
            />
          </div>

          <div class="w-25-porcento px-2">
            <SysFornecedorAutocomplete
              v-model="exportacao.codigo_fornecedor"
              label="Fornecedor*"
              outlined
              hide-details
            />
          </div>

          <div class="w-25-porcento pl-2">
            <SysCodigosPagamentosAutocomplete
              v-model="exportacao.codigo_condicao_pagamento"
              label="Condição de Pagamento*"
              outlined
              hide-details
            />
          </div>
        </div>

        <div class="mt-5">
          <v-textarea
            v-model="exportacao.observacao"
            label="Observação"
            outlined
            hide-details
            :height="75"
          />
        </div>
      </v-card>

      <v-card class="pa-5 mt-5">
        <p class="pa-0 d-flex align-center">
          <v-icon>mdi-calendar-blank-outline</v-icon>
          Configurações de datas em massa
        </p>

        <div class="d-flex">
          <div class="w-full mr-2">
            <SysDatePicker
              v-model="exportacao.data_entrega"
              titulo_label="Data de Entrega"
              :clearable="false"
              :data_minima="DATA_ATUAL"
              outlined
              small
            />
          </div>

          <div class="w-full">
            <SysDatePicker
              v-model="exportacao.data_faturamento"
              titulo_label="Data de Faturamento"
              :clearable="false"
              outlined
              :data_maxima="exportacao.data_entrega"
              :disabled="exportacao.data_entrega === ''"
              small
            />
          </div>
        </div>
      </v-card>

      <v-card class="pa-5 mt-5">
        <p class="ma-0 d-flex align-center">
          <v-icon>mdi-format-list-bulleted</v-icon>
          Lista de Produtos
        </p>

        <sys-data-table
          :headers="cabecalhos"
          :items="produtos_pedido"
          :height="alturaDaJanela - 558"
          :item-height="50"
          hide-default-footer
        >
          <template #item.descricao_produto="{ item }">
            <p class="ma-0 w-max-250">{{ item.descricao_produto }}</p>
          </template>

          <template #item.qtde_pedido="{ item }">
            {{ Helpers.formatarValor(item.qtde_pedido) }}
          </template>

          <template #item.qtde_do_lote="{ item }">
            <div v-if="item.controlado_por_lote === 'S'" class="w-100">
              <TextFieldFormatadorDeValor
                v-model="item.qtde_do_lote"
                :max-digitos="4"
                remover-valor-irrelevante
                centralizar
                outlined
                dense
                hide-details
                :disabled="item.controlado_por_lote !== 'S'"
                @focus="ev => ev.target.select()"
              />
            </div>

            <div v-else>-</div>
          </template>

          <template #item.qtde_em_lote="{ item }">
            {{ Number(item.qtde_do_lote || 0) > 0 ? Helpers.formatarValor(item.qtde_pedido / item.qtde_do_lote) : '-' }}
          </template>

          <template #item.tipo_do_lote="{ item }">
            <div v-if="item.controlado_por_lote === 'S'" class="w-230">
              <TipoLoteAutocomplete
                v-model="item.tipo_do_lote"
                :disabled="item.controlado_por_lote !== 'S'"
              />
            </div>

            <div v-else>-</div>
          </template>

          <template #item.data_entrega="{ item }">
            <div class="w-140">
              <SysDatePicker
                v-model="item.data_entrega"
                titulo_label=""
                :clearable="false"
                :data_minima="DATA_ATUAL"
                outlined
                dense
                hide-details
              />
            </div>
          </template>

          <template #item.data_faturamento="{ item }">
            <div class="w-140">
              <SysDatePicker
                v-model="item.data_faturamento"
                titulo_label=""
                :clearable="false"
                :data_maxima="item.data_entrega"
                :disabled="item.data_entrega === ''"
                outlined
                dense
                hide-details
                left
              />
            </div>
          </template>
        </sys-data-table>
      </v-card>
    </div>
  </SysDialogFullscreen>
</template>

<script>
import {computed, ref, watch} from "vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import SysCodigosPagamentosAutocomplete from "@/components/utils/crud/SysCodigosPagamentosAutocomplete.vue";
import SysDatePicker from "@/components/utils/SysDatePicker.vue";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import moment from "moment/moment";
import TipoLoteAutocomplete from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystockAndra/TipoLoteAutocomplete.vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import ErrosDialog from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystockAndra/ErrosDialog.vue";

export default {
  name: "ExportacaoApiPedidosSystockAndra",
  components: {
    ErrosDialog,
    TextFieldFormatadorDeValor,
    TipoLoteAutocomplete,
    SysCodigosPagamentosAutocomplete,
    SysDialogFullscreen,
    SysFilialGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysDatePicker,
  },
  mixins: [ResponsiveHeight],
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: Boolean,
    pedido: Object,
    produtos_pedido: Array,
  },
  emits: ['update:modelValue'],
  computed: {
    DATA_ATUAL() {
      return moment().format('YYYY-MM-DD');
    },
  },
  setup(props, { emit }) {
    const exportacao = ref({
      codigo_filial: '',
      codigo_comprador: '',
      codigo_fornecedor: '',
      codigo_condicao_pagamento: '',
      observacao: '',
      data_entrega: '',
      data_faturamento: '',
    });

    const produtos_pedido = ref([]);

    watch(() => exportacao.value.data_entrega, () => {
      produtos_pedido.value.forEach(item => item.data_entrega = exportacao.value.data_entrega);
    });

    watch(() => exportacao.value.data_faturamento, () => {
      produtos_pedido.value.forEach(item => item.data_faturamento = exportacao.value.data_faturamento);
    });

    const cabecalhos = [
      { text: "Cód. Interno", value: "idproduto" },
      { text: "Cód. Fornecedor", value: "cod_produto" },
      { text: "Descrição Produto", value: "descricao_produto" },
      { text: "Quantidade", value: "qtde_pedido" },
      { text: "Qt. em Lote", value: "qtde_em_lote" },
      { text: "Qt. do Lote", value: "qtde_do_lote" },
      { text: "Tipo do Lote", value: "tipo_do_lote" },
      { text: "Data Entrega*", value: "data_entrega"},
      { text: "Data Faturamento*", value: "data_faturamento"},
    ];

    const DIALOG_ATIVO_COMPUTED = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor),
    });

    function dialogFechado() {
      DIALOG_ATIVO_COMPUTED.value = false;

      exportacao.value.codigo_filial = '';
      exportacao.value.codigo_comprador = '';
      exportacao.value.codigo_fornecedor = '';
      exportacao.value.codigo_condicao_pagamento = '';
      exportacao.value.observacao = '';
      exportacao.value.data_entrega = '';
      exportacao.value.data_faturamento = '';

      produtos_pedido.value = [];
    }

    watch(DIALOG_ATIVO_COMPUTED, () => {
      if (DIALOG_ATIVO_COMPUTED.value) {
        buscarFiltrosExportacao();
      }
    });

    function buscarFiltrosExportacao() {
      api.get(`pedidos-compra/${props.pedido.idpedido}/exportacao/api-pedidos-systock-andra/filtros`)
        .then(resposta => {
          const { filtros } = resposta.data;

          exportacao.value.codigo_filial = filtros.filial || '';

          if (filtros.compradores.length === 1) {
            exportacao.value.codigo_comprador = filtros.compradores[0];
          }

          if (filtros.fornecedores.length === 1) {
            exportacao.value.codigo_fornecedor = filtros.fornecedores[0];
          }

          if (filtros.condicao_pagamento) {
            exportacao.value.codigo_condicao_pagamento = filtros.condicao_pagamento;
          }

          if (filtros.observacao) {
            exportacao.value.observacao = filtros.observacao;
          }

          produtos_pedido.value = filtros.produtos.map(item => ({
            ...item,
            data_entrega: item.data_entrega ? item.data_entrega : '',
            data_faturamento: item.data_faturamento ? item.data_faturamento : '',
          }));
        })
        .catch(logout)
    }

    const exportacao_valida_computed = computed(() => {
      const produtos_validos = produtos_pedido.value.every(item =>
        item.data_entrega !== ''
        && item.data_faturamento !== ''
        && (item.controlado_por_lote !== 'S' || (Number(item.qtde_do_lote) > 0 && item.tipo_do_lote !== null))
      );

      return exportacao.value.codigo_filial !== ''
        && exportacao.value.codigo_comprador !== ''
        && exportacao.value.codigo_fornecedor !== ''
        && exportacao.value.codigo_condicao_pagamento !== ''
        && produtos_validos;
    });

    function exportar() {
      const parametros = {
        codigo_filial: exportacao.value.codigo_filial,
        codigo_comprador: exportacao.value.codigo_comprador,
        codigo_fornecedor: exportacao.value.codigo_fornecedor,
        codigo_condicao_pagamento: exportacao.value.codigo_condicao_pagamento,
        observacao: exportacao.value.observacao,
        produtos: produtos_pedido.value.map(item => ({
          idproduto: item.idproduto,
          qtde_do_lote: item.qtde_do_lote,
          tipo_do_lote: item.tipo_do_lote,
          data_entrega: item.data_entrega,
          data_faturamento: item.data_faturamento,
        })),
      };

      api.post(`pedidos-compra/${props.pedido.idpedido}/exportacao/api-pedidos-systock-andra`, parametros)
        .then(() => {
          dialogFechado();
        })
        .catch(logout)
    }

    return {
      DIALOG_ATIVO_COMPUTED,
      exportacao,
      produtos_pedido,
      cabecalhos,
      exportacao_valida_computed,
      exportar
    }
  }
}
</script>
